import React from 'react';
import './copyright.css';
import {COPYRIGHT} from '../../constants';
import dizzain from './product-by-dizzain.svg';

const Copyright = () => {
	return (
		<div className="copyright">
			<a target="_blank" rel="noopener noreferrer" href="https://www.dizzain.com/">
				<img src={dizzain} className="copyright__img" alt={COPYRIGHT}/>
			</a>
		</div>
	);
};

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/Copyright/Copyright.js